// extracted by mini-css-extract-plugin
module.exports = {"bodyDescription":"style_bodyDescription__dn6nQ","bodyTitle":"style_bodyTitle__oYkc1","bodyAuthor":"style_bodyAuthor__adMOZ"};